import { captureEvent, captureFailedEvent } from "./testing.js";
import { EventTypes, } from "./event-types.js";
export class Events {
    relay;
    commerceApi;
    currency;
    constructor(relay, commerceApi, currency) {
        this.relay = relay;
        this.commerceApi = commerceApi;
        this.currency = currency;
    }
    async reportSearch(data) {
        await this.emitWithCommerceApi({
            actionCause: "searchboxSubmit",
            originContext: "Search",
            query: data.query,
            products: data.products,
            numberOfResults: data.numberOfResults,
        }, { type: EventTypes.Search, data });
    }
    async reportProductListing(data) {
        await this.emitWithCommerceApi({
            actionCause: "searchboxSubmit",
            originContext: "ProductListing",
            products: data.products,
            numberOfResults: data.numberOfResults,
        }, { type: EventTypes.ProductListing, data });
    }
    async reportProductClick(data) {
        await this.emitWithRelay("ec.productclick", {
            position: data.position,
            responseId: await data.responseId.get(),
            currency: this.currency,
            product: {
                productId: data.productId,
                name: data.name,
                price: data.price,
            },
        }, { type: EventTypes.ProductClick, data });
    }
    async reportProductView(data) {
        await this.emitWithRelay("ec.productview", {
            currency: this.currency,
            product: {
                productId: data.productId,
                name: data.name,
                price: data.price,
            },
        }, { type: EventTypes.ProductView, data });
    }
    async reportAddToCart(data) {
        await this.emitWithRelay("ec.cartAction", {
            action: "add",
            currency: this.currency,
            product: {
                productId: data.productId,
                name: data.name,
                price: data.price,
            },
            quantity: data.quantity,
        }, { type: EventTypes.AddToCart, data });
    }
    async reportPurchase(data) {
        await this.emitWithRelay("ec.purchase", {
            currency: this.currency,
            products: data.products.map((product) => ({
                product: {
                    productId: product.productId,
                    name: product.name,
                    price: product.price,
                },
                quantity: product.quantity,
            })),
            transaction: {
                id: crypto.randomUUID(),
                revenue: data.products.reduce((sum, product) => sum + product.price, 0) || 0,
            },
        }, { type: EventTypes.Purchase, data });
    }
    async emitWithRelay(type, data, originalEvent) {
        if (this.relay != null) {
            try {
                await this.relay.emit(type, data);
                captureEvent(originalEvent);
            }
            catch (error) {
                captureFailedEvent(originalEvent, error);
            }
        }
    }
    async emitWithCommerceApi(data, originalEvent) {
        if (this.commerceApi != null) {
            try {
                // need to check if event is Search or ProductListing
                if (originalEvent.type === EventTypes.Search) {
                    const responseId = await this.commerceApi.emitSearch(data);
                    originalEvent.data.responseId.set(responseId);
                }
                else if (originalEvent.type === EventTypes.ProductListing) {
                    const responseId = await this.commerceApi.emitListing(data);
                    originalEvent.data.responseId.set(responseId);
                }
                captureEvent(originalEvent);
            }
            catch (error) {
                captureFailedEvent(originalEvent, error);
            }
        }
        else {
            captureEvent(originalEvent);
        }
    }
}
//# sourceMappingURL=events.js.map